<div class="Init">
  <header class="sticky-top">
    <div class="header_title text-center py-2">
      <span>{{ $t('header.title') }}</span>
      <LanguageSwitcher />
    </div>
  </header>

  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-4">
    <div class="text-center mt-4">
      <img :alt="$t('alt.banner')" :src="bannerImage" class="img-fluid" />
    </div>
    <div class="text-center mt-4 mx-4">{{ $t('nav.privacy_notice_prefix') }}<a href="/PrivacyPolicy">{{ $t('nav.privacy_notice_link') }}</a></div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="home()">{{ $t('nav.about') }}</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="qa()">{{ $t('nav.faq') }}</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="privacy_policy()">{{ $t('nav.privacy_policy') }}</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="terms_of_service()">{{ $t('nav.terms_of_service') }}</b-button>
    </div>
  </b-container>
  
</div>